import React from 'react'

export default function NotFound() {
  return (
    <>
    <div>Pagina no encontrada</div>
    </>
  )
}